import { FC } from 'react'

interface ErrorMessageProps {
  message: string
}

const ErrorMessage: FC<ErrorMessageProps> = (props) => {
  const { message } = props
  return (
    <p className="flex items-center gap-2 text-sm text-accent bg-accent/10 border border-accent/30 px-3 py-2 w-full rounded-md" role="alert">
      {message}
    </p>
  )
}

export default ErrorMessage
